// TODO: we create this files until we create a unification style for handle api responses, this file has been created in order to reduce duplicated logic with metrics api

import metricsApi from '../../metrics/Api';
import { isServerSide } from '../../../utils/isomorphic';
import { API_TIMEOUT_ERROR } from '../constants';

export default function trovitFetchResponse(promiseResponse, metricsData) {
  const mustSaveMetrics = isServerSide() && typeof metricsData !== 'undefined';
  const startTime = new Date();

  return promiseResponse
    .then(response => {
      if (mustSaveMetrics) {
        const endTime = new Date();
        metricsApi.incrementQuery(metricsData).catch(errorApi => {
          throw errorApi;
        });

        const responseTime = endTime - startTime;
        metricsApi.storeResponseTime({ ...metricsData, responseTime }).catch(errorApi => {
          throw errorApi;
        });
      }

      return response;
    })
    .catch(error => {
      if (!mustSaveMetrics) {
        throw error;
      }

      if (error.name === API_TIMEOUT_ERROR) {
        return metricsApi.incrementTimeout(metricsData).catch(errorApi => {
          throw errorApi;
        });
      }

      return metricsApi.incrementError(metricsData).catch(errorApi => {
        throw errorApi;
      });
    });
}



// WEBPACK FOOTER //
// ./app/sdk/common/handleApiResponses/trovitFetchResponse.js